import { render, staticRenderFns } from "./auctionList.vue?vue&type=template&id=321e1f4e&scoped=true&"
import script from "./auctionList.vue?vue&type=script&lang=js&"
export * from "./auctionList.vue?vue&type=script&lang=js&"
import style0 from "./auctionList.vue?vue&type=style&index=0&id=321e1f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321e1f4e",
  null
  
)

export default component.exports